import React, { Component } from 'react';
import $ from "jquery";
import axios from 'axios';
import DashboardHeading from '../commonFiles/DashboardHeading';
import ChangePassword from './profilePages/ChangePassword';
import ProfileView from './profilePages/ProfileView';
class ViewEmployeeProfile extends Component {
  constructor() {
    super();
    this.state = {
      emp_page:'',
    };
  }


componentDidMount(){
  this.view_user_page('profile');
}
view_user_page(page_type){
  var emp_page = '';
  if(page_type=='change_password'){
    emp_page = <ChangePassword/>;
  }else{
    emp_page = <ProfileView emp_id='1' fullname="Satish Pethkar"/>;
  }
  this.setState({emp_page})
}

  render() {
    return (
        <>
        <DashboardHeading title="Profile"/>
        	<div className="container mt-4 mb-4 Dashboard_main_div">
                <h3 className="wow fadeInUp" data-wow-delay="0.1s">Profile</h3>
                <div className="row g-4">
                  <div className="col-md-3">
                        <button className="btn btn-primary w-100 py-3" type="button" onClick={this.view_user_page.bind(this,'profile')}>Profile</button>
                  </div>
                  <div className="col-md-3">
                        <button className="btn btn-primary w-100 py-3" type="button" id="change_password" onClick={this.view_user_page.bind(this,'change_password')}>Change Password</button>
                  </div>
                </div>

                {this.state.emp_page}
        </div>
        </>
    );
  }
}

export default ViewEmployeeProfile;
